export const gitCommit = 'f02a21fd'
